import * as templates from './templates';

export type NatalieEventConfig = {
  greeting?: string;
  systemPrompt?: string;
  model?: string;
};

/**
 * Maps event IDs to pre-configured agent settings.
 * Multiple events can share the same template.
 *
 * To add a new event configuration:
 * 1. Create a template in ./templates/ (or reuse an existing one)
 * 2. Export it from ./templates/index.ts
 * 3. Map the event ID to the template below
 */
const EVENT_CONFIGS: Record<string, NatalieEventConfig> = {
  'f3396937-f786-45e8-a88a-ab046e917a24': templates.cat_and_dog,
  '045838a5-62ee-466e-87c0-ca8b131dcfad': templates.employee_check_in_agenda,
};

export const getEventConfig = (eventId: string): NatalieEventConfig | undefined => EVENT_CONFIGS[eventId];
